import { Either, fold } from "fp-ts/lib/Either";
import * as t from "io-ts";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { _Error } from "@/lib/wordpress/data";
import { ChatMessage } from "./types";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { pipe } from "fp-ts/lib/function";
import fpJsonParseTypesafe from "@/util/fp-json-parse-typesafe";
import { ioTsToJsonSchema } from "./util";

export async function requestStructuredOutput<A>(
  message: string,
  GuardV: t.Type<A, any, unknown>
): Promise<A | undefined> {
  const ValidGuardV = t.type({
    response: GuardV
  });

  console.log(message);

  const ajaxRequestResponse = await _requestStructuredOutput(
    [
      {
        role: "user",
        content: message
      }
    ],
    {
      name: "my_schema",
      strict: true,
      schema: ioTsToJsonSchema(ValidGuardV)
    }
  );

  const validated = pipe(
    ajaxRequestResponse,
    fold(
      () => {
        // AJAX returned invalid response
        return undefined;
      },
      successfulResponse => {
        console.log("AJAX returned a valid response", successfulResponse);

        const parsedResponse = fpJsonParseTypesafe(
          successfulResponse,
          ValidGuardV
        );

        return pipe(
          parsedResponse,
          fold(
            () => {
              // iots errors
              return undefined;
            },
            validObject => {
              return validObject.response;
            }
          )
        );
      }
    )
  );

  return validated;
}

async function _requestStructuredOutput(
  messages: ChatMessage[],
  json_schema: {}
): Promise<Either<_Error[], string>> {
  return makeWordPressAjaxRequest({
    action: "breakdance_ai_request_structured_output",
    friendlyName: "AI Assistant",
    dataToPost: {
      messages: fpJsonStringify(messages),
      json_schema: fpJsonStringify(json_schema)
    },
    decoder: t.string,
    resultKey: "data"
  });
}
